webpackJsonp([269985143221374],{

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcSteps = __webpack_require__(76);
	
	var _rcSteps2 = _interopRequireDefault(_rcSteps);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Step = __webpack_require__(60);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _gemFlexibel = __webpack_require__(53);
	
	var _gemFlexibel2 = _interopRequireDefault(_gemFlexibel);
	
	var _gemLagspelare = __webpack_require__(54);
	
	var _gemLagspelare2 = _interopRequireDefault(_gemLagspelare);
	
	var _gemDriven = __webpack_require__(52);
	
	var _gemDriven2 = _interopRequireDefault(_gemDriven);
	
	var _gemNinja = __webpack_require__(55);
	
	var _gemNinja2 = _interopRequireDefault(_gemNinja);
	
	var _floskelFlexibel = __webpack_require__(80);
	
	var _floskelFlexibel2 = _interopRequireDefault(_floskelFlexibel);
	
	var _floskelLagspelare = __webpack_require__(81);
	
	var _floskelLagspelare2 = _interopRequireDefault(_floskelLagspelare);
	
	var _floskelDriven = __webpack_require__(79);
	
	var _floskelDriven2 = _interopRequireDefault(_floskelDriven);
	
	var _floskelNinja = __webpack_require__(82);
	
	var _floskelNinja2 = _interopRequireDefault(_floskelNinja);
	
	var _iconGoalOn = __webpack_require__(84);
	
	var _iconGoalOn2 = _interopRequireDefault(_iconGoalOn);
	
	var _iconGoalOff = __webpack_require__(83);
	
	var _iconGoalOff2 = _interopRequireDefault(_iconGoalOff);
	
	var _iconLock = __webpack_require__(85);
	
	var _iconLock2 = _interopRequireDefault(_iconLock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var steps = [{
	  title: 'Flexibel',
	  iconProcess: _react2.default.createElement('img', { alt: '', src: _floskelFlexibel2.default }),
	  iconWait: _react2.default.createElement('img', { alt: '', src: _iconLock2.default }),
	  iconFinish: _react2.default.createElement('img', { alt: '', src: _gemFlexibel2.default }),
	  url: '/flexibel/'
	}, {
	  title: 'Lagspelare',
	  iconProcess: _react2.default.createElement('img', { alt: '', src: _floskelLagspelare2.default }),
	  iconWait: _react2.default.createElement('img', { alt: '', src: _iconLock2.default }),
	  iconFinish: _react2.default.createElement('img', { alt: '', src: _gemLagspelare2.default }),
	  url: '/lagspelare/'
	}, {
	  title: 'Driven',
	  iconProcess: _react2.default.createElement('img', { alt: '', src: _floskelDriven2.default }),
	  iconWait: _react2.default.createElement('img', { alt: '', src: _iconLock2.default }),
	  iconFinish: _react2.default.createElement('img', { alt: '', src: _gemDriven2.default }),
	  url: '/driven/'
	}, {
	  title: 'Ninja',
	  iconProcess: _react2.default.createElement('img', { alt: '', src: _floskelNinja2.default }),
	  iconWait: _react2.default.createElement('img', { alt: '', src: _iconLock2.default }),
	  iconFinish: _react2.default.createElement('img', { alt: '', src: _gemNinja2.default }),
	  url: '/ninja/'
	}, {
	  title: 'Mål',
	  iconProcess: _react2.default.createElement('img', { alt: '', src: _iconGoalOn2.default }),
	  iconWait: _react2.default.createElement('img', { alt: '', src: _iconGoalOff2.default }),
	  iconFinish: _react2.default.createElement('img', { alt: '', src: _iconGoalOn2.default }),
	  url: '/completed/'
	}];
	
	var D = function D(_ref) {
	  var transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Shell', style: transition && transition.style },
	    _react2.default.createElement(
	      _Content2.default,
	      { header: true },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'Steps__heading' },
	          'Vad g\xF6mmer sig bakom floskeln?'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'Steps__wrapper' },
	          _react2.default.createElement(
	            _rcSteps2.default,
	            { className: 'Steps', direction: 'vertical', current: 4 },
	            steps.map(function (s, i) {
	              return _react2.default.createElement(_Step2.default, {
	                className: 'Steps__item',
	                key: i,
	                title: s.title,
	                iconWait: s.iconWait,
	                iconProcess: s.iconProcess,
	                iconFinish: s.iconFinish,
	                url: s.url
	              });
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = D;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-d-js-0746465aa0fb8a40df57.js